exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-input-group__append,.el-input-group__prepend{background-color:#1890ff !important;color:#fff !important;border-color:#1890ff !important;border-radius:0 4px 4px 0}", ""]);

// exports
